<div class="row sk-loading" [ngClass]="getCssClass()" *ngIf="show">
  <div class="plyca_alert row">
    <div class="col-9 plyca_alert_text" *ngIf="loadingMessage">
      <span class="ui-messages-icon fa fa-fw fa-2x fa-info-circle"></span>
      <span [innerHTML]="loadingMessage"></span>
    </div>
    <div class="col-9 plyca_alert_text" *ngIf="isShowCancel()">
      <button class="btn btn-default center-block" (click)="close()" type="button">
        <i class="fas fa-times" aria-hidden="true"></i> {{ 'General.cancel' | translate }} </button>
    </div>
  </div>
  <div class="nb-spinner" role="status">
  </div>
</div>